import React, { useEffect } from 'react';
import PuckInfo from './PuckInfo';
import DewarInfo from './DewarInfo';
import { ButtonsListContainer } from 'components/Button';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import { RMCustomButtonProps } from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { PuckDewarContainerView } from '../puck/constants';
import { useSelectedCrystalId } from 'redux/hooks/synchrotron';
import CrystalImage from 'components/crystal/crystalImage';
import { CrystalDataDTO } from '../constants';
import { getCrystalById } from './utils';
import { hasAnyPropertyOfObjectValue } from 'utils/Global';

interface Props {
  setContentView: (view: PuckDewarContainerView) => void;
  isEditMode: boolean;
  setIsEditMode: React.Dispatch<React.SetStateAction<boolean>>;
  crystals: CrystalDataDTO[];
  setCrystals: React.Dispatch<React.SetStateAction<CrystalDataDTO[]>>;
  onSaveHandler: (...args) => void;
  onDiscardHandler: (...args) => void;
  isReadOnly?: boolean;
}
const PuckDewarInfo = (props: Props) => {
  const {
    setContentView,
    isEditMode,
    setIsEditMode,
    crystals,
    setCrystals,
    onSaveHandler,
    onDiscardHandler,
    isReadOnly,
  } = props;
  const selectedCrystalId = useSelectedCrystalId();
  const selectedCrystal = getCrystalById(crystals, selectedCrystalId);
  // eslint-disable-next-line
  const { isDirty, isUpdated, ...crystalAssignments } =
    selectedCrystal?.crystalContainerAssignments || {};

  const isPuckOrDewarAssigned = hasAnyPropertyOfObjectValue(crystalAssignments);

  useEffect(() => {
    if (!isDirty) {
      if (!isPuckOrDewarAssigned) {
        setIsEditMode(true);
      } else {
        setIsEditMode(false);
      }
    }
  }, [selectedCrystalId]);

  const editButton: RMCustomButtonProps = {
    title: 'EDIT',
    contentContainerClass: 'w-20 h-8 bg-[#006AF5]',
    titleClass: 'text-white',
    onClick: () => {
      setIsEditMode(true);
    },
    isDisabled: isReadOnly,
  };

  const cancelButton: RMCustomButtonProps = {
    title: 'CANCEL',
    contentContainerClass: 'w-20 h-8 bg-[#DA1E28]',
    titleClass: 'text-white',
    onClick: onDiscardHandler,
    isDisabled: !isPuckOrDewarAssigned,
  };
  const buttonsList: RMCustomButtonProps[] = [
    isEditMode ? cancelButton : editButton,
    ...(isEditMode
      ? [
          {
            title: 'APPLY',
            contentContainerClass: 'w-20 h-8 bg-[#4CAF50]',
            titleClass: 'text-white',
            isDisabled: !isDirty || isReadOnly,
            onClick: onSaveHandler,
          },
        ]
      : []),
  ];

  if (!selectedCrystalId) {
    return (
      <div
        id="puckdewarcontainer-puckdewarinfo-wrapper"
        className="flex flex-col w-full px-[2%] h-full justify-center items-center"
      >
        <RMSvgIcon
          id="puckdewarcontainer-puckdewarinfo-icon"
          width={50}
          height={50}
          name="CrystalDefinition"
          fill="#CACACA"
        />
        <div
          id="puckdewarcontainer-puckdewarinfo-warning-message"
          className="text-[#CACACA] text-base text-center mt-2"
        >
          Please select crystal data to be able to show the Puck and Dewar option
        </div>
      </div>
    );
  }
  return (
    <div
      id="puckdewarcontainer-puckdewarinfo-wrapper"
      className="flex flex-col w-full px-[2%] h-full"
    >
      <div
        id="puckdewarcontainer-puckdewarinfo-crystal-image"
        className="flex items-center justify-center w-full h-[35%] my-2"
      >
        <CrystalImage crystalId={selectedCrystalId} />
      </div>
      <div
        id="puckdewarcontainer-puckdewarinfo-empty"
        className="w-full h-px bg-[#D9D9D9]"
      ></div>

      <div
        id="puckdewarcontainer-puckdewarinfo-details"
        className="w-full h-[65%] px-2 py-2 overflow-y-auto"
      >
        <PuckInfo
          setContentView={setContentView}
          disabled={!isEditMode || isReadOnly}
          crystals={crystals}
          setCrystals={setCrystals}
        />
        <DewarInfo
          setContentView={setContentView}
          disabled={!isEditMode || isReadOnly}
          crystals={crystals}
        />
        <div
          id="puckdewarcontainer-puckdewarinfo-details-button-list"
          className="flex flex-row justify-end"
        >
          <ButtonsListContainer buttonsList={buttonsList} marginBetweenItems={'0.5rem'} />
        </div>
      </div>
    </div>
  );
};

export default PuckDewarInfo;
